module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/ranking-fedb13be2d475d7ad3e9449f54633b60.png";